import type { RentalsMerchantPortalRouter } from "@src/backend/src/rentals/functions/merchantsPortal";
import { useStytch } from "@stytch/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import { PropsWithChildren, useState } from "react";
import { TRPCProvider as TRPCContextProvider } from "./index";

export function TRPCProvider({ children }: PropsWithChildren) {
  const stytch = useStytch();

  const [queryClient] = useState(() => new QueryClient());

  const [trpcClient] = useState(() =>
    createTRPCClient<RentalsMerchantPortalRouter>({
      links: [
        httpBatchLink({
          maxItems: 5,
          url: import.meta.env.VITE_TRPC_API_URL,
          async headers() {
            return {
              authorization: stytch.session.getTokens()?.session_token,
            };
          },
        }),
      ],
    })
  );

  return (
    <TRPCContextProvider trpcClient={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TRPCContextProvider>
  );
}
